<template>
    <div>
        <v-data-table
            v-if="listItems && listItems.length > 0"
            :headers="headers"
            :items="listItems"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalRecords"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [5, 10, 20, 50],
            }"
        >
            <template v-slot:[`item.isActive`]="{ item }">
                <v-chip
                    :color="getColor(item.isActive)"
                    pill
                    dark
                    small
                    class="status-column"
                >
                    {{ getTextState(item.isActive) }}
                </v-chip>
            </template>

            <template
                v-slot:[`item.actions`]="{ item }"
                v-if="showReservePackButtons()"
            >
                <v-tooltip v-if="checkDate(item.endDate)" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="moduleEdit(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/edit_pencil.svg"
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.components.datatable-reserve-pack.edit-pack"
                        )
                    }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            style="cursor: pointer"
                            class="circle mr-2 p-0"
                            v-bind="attrs"
                            v-on="on"
                            @click="$emit('on-get-history-pack', item)"
                        >
                            <img
                                src="/images/_SVGs/bo/eye.svg"
                                alt="visualizar"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.components.datatable-reserve-pack.transfer-history"
                        )
                    }}</span>
                </v-tooltip>
            </template>

            <template v-slot:[`item.creationDateTime`]="{ item }">
                <span>
                    {{ item.creationDateTime | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                <span>
                    {{ item.endDate | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:[`footer.prepend`]>
                <div class="d-flex flex-column">
                    <v-chip
                        class="ml-8 mt-1"
                        :class="index == balance.length - 1 ? 'mb-1' : ''"
                        v-for="(item, index) in balance"
                        :key="item.name"
                    >
                        <span class="span-title-footer">{{
                            `${item.name} | ${$t(
                                "backoffice.modules-management.vrm.components.datatable-reserve-pack.actual-balance"
                            )}`
                        }}</span>
                        <span class="span2-title-footer">{{ item.value }}</span>
                    </v-chip>
                </div>
            </template>
        </v-data-table>

        <v-col class="mt-1" v-if="showReservePackButtons()">
            <v-btn
                fab
                dark
                x-small
                color="var(--v-primary-base)"
                @click="onClickReservePack"
            >
                <v-icon dark> mdi-plus </v-icon>
            </v-btn>
            <span @click="onClickReservePack" class="ml-3 span-packs">{{
                $t(
                    "backoffice.modules-management.vrm.components.datatable-reserve-pack.create-reserve-pack"
                )
            }}</span>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listItems: null,
        searchCount: Number,
        billingTypeId: 0,
        totalRecords: Number,
        balance: Array,
        user: Object,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.invoice"
                    ),
                    value: "invoiceNumber",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.obs"
                    ),
                    value: "observations",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.qty"
                    ),
                    align: "start",
                    value: "chargedBalance",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.current-balance"
                    ),
                    value: "currentBalance",
                    align: "start",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.status"
                    ),
                    value: "isActive",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.create-date"
                    ),
                    value: "creationDateTime",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.end-date"
                    ),
                    value: "endDate",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.access-type-form.vehicle-typology"
                    ),
                    value: "packVehicleTipology",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-reserve-pack.headers.datasource"
                    ),
                    value: "dataSource",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.created-by"),
                    value: "createdBy",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTableDatatableReservePack", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTableDatatableReservePack", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
        deep: true,
    },
    computed: {
        checkRoleIdByLoggedInUser() {
            return this.$store.getters["auth/getState"].roleId;
        },
    },
    methods: {
        showReservePackButtons() {
            return (
                this.checkRoleIdByLoggedInUser == this.$globals.ROLES.ADMIN &&
                this.user.isCompanyBellowTips
            );
        },
        checkDate(date) {
            return (
                this.billingTypeId != 4 &&
                (new Date(date) >= new Date() ||
                    this.checkRoleIdByLoggedInUser == this.$globals.ROLES.ADMIN)
            );
        },
        getColor(isActive) {
            if (isActive == true) return "green";
            else if (isActive == false) return "red";
            else return "orange";
        },

        getTextState(status) {
            if (status == true)
                return this.$t("backoffice.general.active-status");
            else if (status == false)
                return this.$t("backoffice.general.inactive-status");
        },
        moduleEdit(item) {
            this.$emit("reserve-pack-edit", item);
        },

        onClickReservePack() {
            this.$emit("reserve-pack-datatable-btn");
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#content-backoffice {
    table {
        thead {
            tr {
                th {
                    border: 0;
                    
                    &.header-table-color {
                        background-color: #f2f2f2 !important;
                        color: #9e9d9d !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 12px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }

    .span-packs {
        color: var(--v-primary-base);
        cursor: pointer;
    }
}
</style>
